import { BreadCrumbs } from '@/shared/ui/Breadcrumbs/Breadcrumbs'
import {
  ResidentialAmenitiesView,
  UnitAmenitiesView,
  EnumsView,
  PublicOfferView,
  MessageTemplatesView,
  DefaultManagerView,
} from '@/widgets/Settings/LibraryView'

export const Library = () => {
  return (
    <>
      <BreadCrumbs />
      <DefaultManagerView />
      <PublicOfferView />
      <ResidentialAmenitiesView />
      <UnitAmenitiesView />
      <MessageTemplatesView />
      <EnumsView />
    </>
  )
}
